const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/recurring-bookings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Calendar } from 'lucide-react';
export const Route = createFileRoute('/dashboard/recurring-bookings')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

type Frequency = 'daily' | 'weekly' | 'biweekly' | 'monthly';
type TemplateStatus = 'active' | 'paused' | 'completed' | 'cancelled';
interface RecurringTemplate {
  id: string;
  petName: string;
  ownerName: string;
  ownerEmail?: string;
  ownerPhone?: string;
  serviceName?: string;
  serviceType?: string;
  frequency: Frequency;
  dayOfWeek?: number;
  dayOfMonth?: number;
  intervalValue: number;
  preferredTime: string;
  preferredMemberId?: string;
  startDate: string;
  endDate?: string;
  maxOccurrences?: number;
  occurrencesCreated: number;
  nextOccurrenceDate?: string;
  lastGeneratedDate?: string;
  status: TemplateStatus;
  estimatedPrice?: number;
  notes?: string;
  createdAt: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

// ─── Create Modal ────────────────────────────────────────────────────────────